
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Slider from 'react-slick';
import classNames from 'classnames';

import routeConfiguration from '../../routing/routeConfiguration';
import { priceData } from './ListingPage.shared';
import { ensureUser, stringFromLength } from '../../util/data';
import { createResourceLocatorString } from '../../util/routes';
import { types as sdkTypes } from '../../util/sdkLoader';

import { Avatar, Button, IconCard, IconClose, IconDeetsLinkedin, IconProfileCard, IconSpinner, Modal, NamedLink, ResponsiveImage, ReviewRating } from '../../components';
import SectionMapMaybe from './SectionMapMaybe';
import { Link } from '../PageBuilder/Primitives/Link';

import css from './ListingPage.module.css';
import { MINIMUM_TOKEN_DEDUCTION } from '../../util/constants';

const { Money } = sdkTypes;

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (<div
    className={className}
    style={{ ...style, display: "block" }}
    onClick={onClick}
  >
    <svg width="21" height="39" viewBox="0 0 21 39" fill="none">
      <path d="M2 36.7707L19 19.8553L2 2.93994" stroke="#e57552" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>);
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (<div
    className={className}
    style={{ ...style, display: "block" }}
    onClick={onClick}
  >
    <svg width="21" height="39" viewBox="0 0 21 39" fill="none">
      <path d="M2 36.7707L19 19.8553L2 2.93994" stroke="#e57552" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div >);
}

const SectionPro = props => {
  const {
    isAuthenticated,
    intl,
    config,
    reviews,
    richTitle,
    share,
    listView,
    currentUser,
    currentListing,
    setShowModal,
    currentTab,
    setCurrentTab,
    filterTabs,
    listingConfig,
    currentUserListings,
    onManageDisableScrolling,
    showPortfolio = false,
    isOwnListing,
    tokensToDeduct = { tokensToDeduct },
    setTokensToDeduct = { setTokensToDeduct },
    isClosed,
    history,
    roleListingFromMongo,
    parentJobRolesInProgress
  } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const portfolioSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    arrows: false,

    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const {
    description = '',
    geolocation = null,
    price = null,
    publicData = {},
  } = (currentListing.id && currentListing.attributes) || {};
  const {
    educations = [],
    experiences = [],
    people = [],
    portfolio = [],
    skills = [],
    listingType,
    location: listingLocation,
    q_as,
    addSelfie1,
    addSelfie2,
    uploadVideoInPhotoes,
    skillsInOne,
    higherEducation
  } = publicData;



  const mediaList = [];
  if (currentListing.images[0]) {
    mediaList.push({ type: 'image', src: currentListing.images[0] });
  }
  if (uploadVideoInPhotoes) {
    mediaList.push({ type: 'video', src: uploadVideoInPhotoes });
  }
  if (currentListing.images[1]) {
    mediaList.push({ type: 'image', src: currentListing.images[1] });
  }

  const imageCount = mediaList.filter(m => m.type === 'image' && m.src).length;
  const videoCount = mediaList.filter(m => m.type === 'video' && m.src).length;

  let enableDots = false;
  let customSlidesToShow = mediaList.length;
  if (imageCount === 2) {
    enableDots = true;
    customSlidesToShow = 2
  } else if (imageCount === 0 || (videoCount > 0 && imageCount === 1)) {
    enableDots = true;
    customSlidesToShow = 2;
  }
  else {
    enableDots = false;
    customSlidesToShow = 1
  }

  const imageSettings = {
    dots: enableDots,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: customSlidesToShow > 1,
    nextArrow: customSlidesToShow > 1 ? <SampleNextArrow /> : null,
    prevArrow: customSlidesToShow > 1 ? <SamplePrevArrow /> : null,
  };

  const { address = '' } = listingLocation || {};
  const currentAuthor = (currentListing && currentListing.id && currentListing.author) || {};
  const ensuredAuthor = ensureUser(currentAuthor);

  const companyIndustries = [], companyRoles = [], companySkills = [], companyFavTools = [];
  if (currentUserListings && currentUserListings?.length) {
    currentUserListings.map(cl => {
      if (cl.attributes.publicData.roles && cl.attributes.publicData.roles?.length) {
        companyRoles.push(...cl.attributes.publicData.roles.map(role => role.label));
        companyIndustries.push(...cl.attributes.publicData.roles.map(role => (role.relevantSkill && role?.relevantSkill.length ? role.relevantSkill.map(skill => skill.label) : [])).flat(1));
      }
      if (cl.attributes.publicData.skills && cl.attributes.publicData.skills?.length) {
        companySkills.push(...cl.attributes.publicData.skills.map(role => role.label));
        companyFavTools.push(...cl.attributes.publicData.skills.map(role => (role.favouriteTool && role?.favouriteTool?.length ? role.favouriteTool.map(skill => skill.label) : [])).flat(1));
      }
    });
  }
  let dataUniqueEducation = []
  const uniqueEducation = (educations && educations?.length) ? educations.map((all, i) => (
    <>
      {(all && all.completedDegree && all.completedDegree.label) ? dataUniqueEducation.push(all.completedDegree.label) : null}
    </>
  )) : [];
  dataUniqueEducation = [... new Set(dataUniqueEducation)]

  const filteredExperiences = experiences && experiences?.length && Array.isArray(experiences) &&  experiences?.filter(experience => experience?.inputValues?.availableHoursPerWeek).map(experience => {
    const { parentJobRoles } = listingConfig;
    const tokensPerConfigListing = roleListingFromMongo?.find(role => role?.key === experience?.key)?.tokens || MINIMUM_TOKEN_DEDUCTION;
    //Assign tokens to each experience by referencing the parentJobRoles in configListing.js
    // TODO: Remove tokens value key pair from experience array in Sharetribe
    return {
      ...experience,
      tokens: tokensPerConfigListing,
    }
  });;
  useEffect(() => {
    setSelectedExperience(filteredExperiences[0])
  }, [roleListingFromMongo])


  const uniqueExperiences =
    Array.isArray(experiences) && experiences?.length > 0
      ? [
        ...new Set(
          experiences
            .map(exp => {
              const industry = exp?.inputValues?.industry ?? [];

              if (Array.isArray(industry)) {
                return industry.map(i => (i?.label ? i.label : i));
              } else if (typeof industry === 'object' && industry !== null) {
                return [industry.label];
              }

              return [];
            })
            .flat(1)
            .filter(Boolean)
        ),
      ]
      : [];

  const uniqueFavTools = skills && skills.length && Array.isArray(skills)
    ? [
      ...new Set(
        skills
          .map(({ inputValues }) =>
            inputValues?.favouriteTool
              ? Array.isArray(inputValues.favouriteTool)
                ? inputValues.favouriteTool.map(tool => tool?.label).filter(Boolean)
                : [inputValues.favouriteTool?.label].filter(Boolean)
              : []
          )
          .flat()
      ),
    ]
    : [];

  const {
    workType,
    location: authorLocation,
    mainProfession,
  } = ensuredAuthor?.attributes?.profile?.publicData || {};

  const [showMore, setShowMore] = useState(false);
  const [seeAll, setSeeAll] = useState(false);
  const [openModal, setOpenModal] = useState({ show: false, data: {} });
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState(filteredExperiences[0] ?? {});
  const [isLoading, setIsLoading] = useState(true);
  const { inputValues: selectedRateAndHours } = selectedExperience || {};
  const currentListingPrice = currentListing?.attributes?.publicData?.experiences?.[0].inputValues || {};
  const [newPrice, setNewPrice] = useState(null);
  useEffect(() => {
    if (currentListingPrice) {
      const computedPrice = priceData(
        currentListingPrice?.price
          ? new Money(currentListingPrice?.price, price?.currency)
          : price,
        config?.currency,
        intl
      );
      setNewPrice(computedPrice);
    }
  }, [currentListingPrice]);

  const accountType = currentUser?.attributes?.profile?.publicData?.accountType;
  const { formattedPrice, formattedPriceFractional } = React.useMemo(() => {
    if (isLoading && accountType === 'fractionalPro') {
      return { formattedPrice: null, formattedPriceFractional: <IconSpinner /> };
    }

    return priceData(
      selectedRateAndHours && selectedRateAndHours?.price ? new Money(selectedRateAndHours?.price, price?.currency)
        : price,
      config?.currency,
      intl
    );
  }, [selectedRateAndHours, price, config?.currency, intl, isLoading]);

  useEffect(() => {
    if (accountType === 'fractionalPro' && roleListingFromMongo) {
      setIsLoading(false);
    }
  }, [roleListingFromMongo]);

   useEffect(() => {
    if (selectedExperience?.tokens) setTokensToDeduct(selectedExperience.tokens);
  }, [selectedExperience])

  const scrollPage = (e, tab) => {
    e.preventDefault();
    if (e && e.currentTarget && e.currentTarget.href) {
      const element = document.getElementById(e.currentTarget.href.split('#')[1]);
      const offset = 55;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      try {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } catch (error) {

      }
    }
  }
  let combineSkill = [], combineSpecialist = [], techTools = []
  if (skillsInOne && skillsInOne.length) {
    skillsInOne.map(({ childSkills }) => {
      (childSkills && childSkills?.length) ? childSkills?.map(({ label, favouriteTools, specialties }
      ) => {
        combineSkill?.push(label);
        favouriteTools && favouriteTools?.map(({ label }) => {
          techTools.push(label)
        })
        specialties
          && specialties
            ?.map(({ label }) => {
              combineSpecialist?.push(label)
            })
      }) : null
    })
  }

  const firstSkill = skillsInOne?.length > 0 ? skillsInOne[0] : null;
  const firstSkillSpecialties =
    firstSkill && firstSkill?.childSkills && firstSkill?.childSkills?.length > 0
      ? firstSkill?.childSkills[0]?.specialties || []
      : [];

  // Conditional variable(s) for display of components 
  const hideFractionalMedia = !isOwnListing && (!isAuthenticated || !showPortfolio);
  const boardMember = (experiences && experiences.length && Array.isArray(experiences) && experiences[0]?.boardMember) || false;

  const fractionalVerificationData = currentListing?.attributes?.metadata?.fractionalVerificationData || [];

  const completedVerifications = fractionalVerificationData?.filter(
    v => ['In Progress', 'Complete'].includes(v?.status)
  );

  return (
    <>
      <div className={css.contentWrapperForProductLayout} id={'divToPrint'}>
        <div className={css.listingGrid}>
          <div className={css.leftGird}>
            {(currentUser && currentUser.id && isAuthenticated)
              ? <div className={css.rotateHeading}>
                <h1> Hello, {currentUser.attributes.profile.firstName}</h1>
              </div>
              : null}
            <div className={css.heroSlider}>
              <Slider {...imageSettings}>
                {mediaList.map((media, index) => (
                  <div
                    key={index}
                    onContextMenu={(e) => e.preventDefault()}
                    className={classNames(
                      media.type === 'image' ? css.listingImageBox : css.videoBox,
                      hideFractionalMedia && (media.type === 'image' ? css.disableOverlay : css.disableOverlayVideo)
                    )}
                  >
                    {media.type === 'image' ? (
                      <ResponsiveImage
                        alt={`display image ${index}`}
                        image={media.src}
                        variants={['default']}
                      />
                    ) : (
                      <video key={media.src} controls>
                        <source src={media.src} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </div>
                ))}
              </Slider>
            </div>
            <div className={css.mobileSpaceBox}>
              <div className={css.headingDescription}>
                <div className={css.mobileActionIcon} id={'Bio'}>
                  <div className={css.specialistTitle}>{listingType == 'fractionalPro' ? 'Fractional' : 'Company'} | {listingConfig?.newCompanyIndustry.find(ind => ind.option === mainProfession)?.label}</div>
                  <h2 className={css.mainHeadingName}> Meet {showPortfolio ? richTitle : 'Your Fractional PRO'}   </h2>
                  <p className={css.description}>
                    {typeof description === 'string' ? (
                      showMore === 'description' || description?.length <= 274
                        ? description
                        : stringFromLength(description, 274, true)
                    ) : null}
                    {typeof description === 'string' && description?.length > 274 && (
                      <span
                        className={css.showmore}
                        onClick={() =>
                          setShowMore(showMore === 'description' ? false : 'description')
                        }
                      >
                        {showMore === 'description' ? ' READ LESS' : ' READ MORE'}
                      </span>
                    )}
                  </p>
                </div>
              </div>
              {isAuthenticated ? <>
                {reviews && reviews.length && Array.isArray(reviews)
                  ? <div className={css.reviewContainer} id={'Reviews'}>
                    <div className={css.reviewHeader}>
                      <h4>Reviews</h4>
                      {reviews.length > 2
                        ? <div className={css.seeAllLink}>
                          <Button onClick={() => setSeeAll('REVIEWS')}>See All ({reviews.length})</Button>
                        </div>
                        : null}
                    </div>
                    <div className={css.reviewBox}>
                      {reviews.map((review, i) => {
                        const {
                          author: {
                            attributes: {
                              displayName,
                              firstName,
                              lastName
                            }
                          },
                          content } = review || {};

                        return i < 2 && (
                          <div className={css.reviewList} key={review.id.uuid}>
                            <div className={css.reviewLeftSide}>
                              <Avatar user={review.author} />
                            </div>
                            <div className={css.reviewRightSide}>
                              <div className={css.ratingStar}>
                                <ReviewRating rating={review.attributes.rating} />
                              </div>
                              <div className={css.reviewName}>
                                <span className={css.boldName}>{displayName}</span>
                                <span className={css.normalName}>| {`${firstName} ${lastName}`}</span>
                              </div>
                              <div className={css.reviewMessage}>
                                {content}
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  : null}
                {experiences && experiences.length && isAuthenticated
                  ? <div className={css.careerHistory} id={'History'}>
                    <div className={css.careeerHeader}>
                      <h4>Currently</h4>
                      {experiences.length > 2
                        ? <div className={css.seeAllLink}>
                          <Button onClick={() => setSeeAll('EXPERIENCE')}>See All ({experiences.length})</Button>
                        </div>
                        : null}
                    </div>
                    <div className={css.careerGrid}>
                      {experiences.map((ex, i) => {
                        const {
                          key,
                          label,
                          highlights = [],
                          inputValues: {
                            industry = {},
                            yearOfExperience = {}
                          }
                        } = ex;

                        return i < 2 && (
                          <div className={css.careerList} key={key}>
                            <div className={css.companyHeld}>{(industry && industry.label) ? industry?.label + ' |' : null}  {label}</div>
                            <div className={css.careerDate}>{yearOfExperience.label}</div>

                          </div>
                        )
                      })}
                    </div>
                  </div>
                  : null}
                {(showPortfolio || isOwnListing) && portfolio && portfolio.length && isAuthenticated
                  ? <div className={css.careerHistory} id={'Portfolio'}>
                    <div className={css.careeerHeader}>
                      <h4>Past Roles</h4>
                    </div>
                    <div className={css.portfolioSlider}>
                      {portfolio.map((p, i) => {
                        const { title, tellMore, imageURL, tellMore_1, tellMore_2, tellMore_3, tellMore_4, tellMore_5 = '', ...rest } = p;
                        return (
                          <div key={title} className={css.sliderBox}>
                            <div className={css.sliderData}>
                              <div className={css.sliderHeading}>
                                {title}
                              </div>

                              <div className={css.sliderSubHeading}>
                                <div className={css.moreSub}>
                                  {/* <span>{tellMore_1}</span>
                                  {tellMore_2 ? <p onClick={() => { setOpenModal({ show: true, data: { ...p } }) }}>See all</p> : null} */}
                                </div>

                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  : null}

                {educations && educations?.length && isAuthenticated ? (
                  <div className={css.careerHistory} id={'Education'}>
                    <div className={css.careeerHeader}>
                      <h4>Education</h4>
                      {educations.length > 2
                        ? <div className={css.seeAllLink}>
                          <Button onClick={() => setSeeAll('EDUCATION')}>See All ({educations.length})</Button>
                        </div>
                        : null}
                    </div>
                    <div className={css.careerGrid}>
                      {educations?.slice(0, 2).map((ed, i) => {
                        const { institution, completedDegree = {} } = ed;
                        if (
                          higherEducation?.label === 'Learned on my own' &&
                          i === 0
                        ) {
                          return (
                            <div className={css.careerList} key="learned-on-my-own">
                              <div className={css.companyHeld}>
                                {higherEducation?.label}
                              </div>
                            </div>
                          );
                        }
                        if (higherEducation?.label === 'Learned on my own') {
                          return null;
                        }

                        return (
                          <div className={css.careerList} key={`edu-${i}`}>
                            <div className={css.companyHeld}>
                              {higherEducation?.label !== 'Secondary'
                                ? `${institution} | ${completedDegree?.label}`
                                : institution}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {educations?.some(ed =>
                      Object.entries(ed)
                        .filter(([key]) => key !== 'institution' && key !== 'completedDegree')
                        .some(([_, value]) => typeof value === 'string' && value.trim().length > 0)
                    ) && (
                        <div className={css.careerGrid}>
                          <div className={css.careeerHeader}>
                            <h4>Certifications & Accreditations</h4>
                          </div>
                          {educations?.map((ed, i) => {
                            const { institution, completedDegree, ...rest } = ed;

                            return Object.values(rest).map((achievement, j) => {
                              if (typeof achievement !== 'string' || achievement.trim().length === 0) return null;

                              const achievementKey = `achievement-${i}-${j}`;
                              const isLong = achievement.length > 138;

                              return (
                                <div className={css.careerList} key={achievementKey}>
                                  <div className={css.companyHeld}>
                                    {showMore === achievementKey || !isLong
                                      ? achievement
                                      : stringFromLength(achievement, 138, true)}

                                    {isLong && (
                                      <span
                                        className={css.showmore}
                                        onClick={() => setShowMore(achievementKey)}
                                      >
                                        {showMore === achievementKey ? ' READ LESS' : ' READ MORE'}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            });
                          })}
                        </div>
                      )}
                  </div>
                ) : null}

              </>
                : null}
            </div>
            <div className={css.expertise}>
              {experiences && experiences.length
              ? <div className={css.qualificationBox}>
                <div className={css.qualificationHeading}>Expertise</div>
                <div className={css.qualificationList}>
                  {experiences.map(({ key, label, inputValues }, i) => {
                    // const index = selectedSkills.findIndex(skill => skill.key == key);
                    return (
                      <span
                        key={key + '-' + label + '-' + i}
                        className={classNames(css.qualificationName, companyRoles.includes(label) && css.SelectedPills)}
                        onClick={() => {
                          // if (selectedSkills && selectedSkills.length > 1) {
                          //   if (index > -1) {
                          //     setSelectedSkills([...selectedSkills.filter(skill => skill.key != key)]);
                          //   } else {
                          //     setSelectedSkills([...selectedSkills, { key, ...inputValues }]);
                          //   }
                          // } else if (index == -1) {
                          //   setSelectedSkills([...selectedSkills, { key, ...inputValues }]);
                          // }
                        }}>
                        {companyRoles.includes(label) ? <IconProfileCard type="tick" /> : null}
                        {label}
                      </span>)
                  })}
                </div>
              </div>
              : null}
            {dataUniqueEducation && dataUniqueEducation.length && higherEducation?.label !== 'Secondary' && higherEducation?.label !== 'Learned on my own'
              ? <div className={css.qualificationBox}>
                <div className={css.qualificationHeading}>Qualifications</div>
                <div className={css.qualificationList}>

                  {(dataUniqueEducation.map((val, i) => {
                    return <span key={i} className={css.qualificationName}>{val}</span>
                  }))}


                </div>
              </div>
              : null}
            {uniqueExperiences && uniqueExperiences?.length &&
              uniqueExperiences?.filter(exp => typeof exp === 'string' && exp?.trim() !== '').length > 0
              ? (
                <div className={css.qualificationBox}>
                  <div className={css.qualificationHeading}>
                    Industries
                  </div>
                  <div className={css.qualificationList}>
                    {uniqueExperiences?.map((experience, i) => (
                      <span
                        key={i + '-' + experience}
                        className={classNames(
                          css.qualificationName,
                          companyIndustries?.includes(experience) && css.SelectedPills
                        )}
                      >
                        {companyIndustries?.includes(experience) ? (
                          <IconProfileCard type="tick" />
                        ) : null}
                        {experience}
                      </span>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>

            {/* 
            {educations && educations.length && isAuthenticated ? null : <div>
              <br />
              <hr />
              <div className={css.notSignedInContent}>
                <h4>Join Forteh to view the whole Profile.</h4>
                <NamedLink name="SignupPage"><Button>Signup</Button></NamedLink>

              </div>
            </div>} */}
          </div>
          <div className={css.rightGrid}>
            <div className={css.availabilityWeek}>
              <div className={css.availabilityText}>
                {filteredExperiences?.length > 0
                  ? filteredExperiences?.length === 1
                    ? <>
                      <span className={css.boldText}>{filteredExperiences[0].label}</span>
                    </>
                    : <select onChange={(e) => {
                      const selectedEx = filteredExperiences?.find(ex => ex.label == e.target.value);
                      setSelectedExperience(selectedEx);
                    }}>
                      {filteredExperiences?.map((experience, i) => <option key={experience.key + '-' + i} value={experience.label}>
                        {experience?.label}
                      </option>)}
                    </select>
                  : null}
              </div>
              <div className={css.actionIcon}>
                {isAuthenticated && !isOwnListing
                  ? <div onClick={() => setShowModal('Notes')} className={css.listView}>
                    <IconCard brand={"listView"} />
                  </div>
                  : null}
                <div onClick={() => setShowModal('Share')}>
                  <IconCard brand={"share"} />
                </div>
              </div>
            </div>
            {/* {experiences && experiences.length && isAuthenticated
              ? <div className={css.careerHistory} id={'History'}>
                <div className={css.careeerHeader}>
                  {experiences.length > 2
                    ? <div className={css.seeAllLink}>
                      <Button onClick={() => setSeeAll('EXPERIENCE')}>See All ({experiences.length})</Button>
                    </div>
                    : null}
                </div>
                <div className={css.careerGrid}>
                  {experiences.map((ex, i) => {
                    const {
                      key,
                      label,
                      highlights = [],
                      inputValues: {
                        industry = {},
                        yearOfExperience = {}
                      }
                    } = ex;

                    return i < 2 && (
                      <div className={css.careerList} key={key}>
                        <div className={css.companyHeld}>  {label}</div>
                      </div>
                    )
                  })}
                </div>
              </div>
              : null} */}
            <div className={css.ver}>
              {completedVerifications?.length > 0 && (
                <div className={css.verificationBadge}>
                  <span className={css.button}>Verified</span>
                  <div className={css.tooltip}>
                    <ul className={css.verificationList}>
                      {completedVerifications?.map((v, index) => (
                        <li key={index} className={css.verificationItem}>
                          {index + 1}.  {v?.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

            </div>

            <div className={css.mapBox}>
              {address && geolocation && authorLocation
                ? <div className={css.mapLocation} id={'mapbox'} >
                  <SectionMapMaybe
                    listingId={currentListing.id}
                    geolocation={{
                      "_sdkType": "LatLng",
                      "lat": authorLocation.selectedPlace.origin.lat,
                      "lng": authorLocation.selectedPlace.origin.lng
                    }
                    }
                    publicData={ensuredAuthor?.attributes.profile.publicData}
                    mapsConfig={config.maps}
                  />
                </div>
                : null}
              <div className={css.locationList}>
                {authorLocation && authorLocation.search
                  ? <div className={css.locationName}>
                    <IconProfileCard type="location" />
                    <span>{authorLocation.search}</span>
                  </div>
                  : null}
                {workType
                  ? <div className={css.locationName}>
                    <IconProfileCard type="location" />
                    <span>Location Preference: {workType == 'flexible' ? "Flexible to anything" : workType.charAt(0).toUpperCase() + workType.slice(1)}</span>
                  </div>
                  : null}
                {authorLocation && <div className={css.locationName}>
                  <IconProfileCard type="time" />
                  <span>Time zone: {authorLocation && authorLocation.timezone ? moment().tz(authorLocation.timezone).format('z') : "NA"}</span>
                </div>}
                {(filteredExperiences && filteredExperiences.length > 0 && filteredExperiences[0]?.inputValues?.wantToHire == 'yes') ?
                  <div className={css.locationName}>
                    <IconProfileCard type="time" />
                    <span>Open to fractional salaried position</span>
                  </div> : null}
                {(filteredExperiences && filteredExperiences?.length > 0 && filteredExperiences[0]?.inputValues?.equity == 'yes') ?
                  <div className={css.locationName}>
                    <IconProfileCard type="time" />
                    <span>Open to Equity</span>
                  </div> : null}
              </div>
            </div>
            {(experiences && experiences.length == 1) ? (skillsInOne && skillsInOne.length) ?
              <div className={css.qualificationBox} id={'Skills'}>
                <div className={css.qualificationHeading}>Skills</div>
                <div >
                  <span  >
                    {
                      (combineSkill && combineSkill.length) ? new Set([...combineSkill]).map((label) => {
                        return (
                          <div className={css.qualificationList}>
                            <div className={classNames(css.experiencePopup)}>
                              <div className={css.parentElement}>{label}</div>
                            </div>
                          </div>
                        )
                      }) : null
                    }
                    {firstSkillSpecialties && firstSkillSpecialties?.length > 0 && (
                      <div className={css.qualificationBox}>
                        <div className={css.qualificationHeading}>Specialties</div>
                        <div className={css.qualificationList}>
                          {firstSkillSpecialties?.map(s => (
                            <div key={s?.key} className={css.qualificationName}>
                              {s?.label}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {(techTools && techTools.length) ?
                      <div>
                        <div className={css.qualificationHeading}>Tech Tools</div>
                        <div className={css.qualificationList}>

                          {new Set([...techTools])?.map((label) => {
                            return <div className={css.qualificationName}>{(label && typeof label != 'object') ? label : ''}</div>
                          })}
                        </div>
                      </div>
                      : null}
                  </span>
                </div>
              </div>
              : (skills && skills.length)
                ? <div className={css.qualificationBox} id={'Skills'}>
                  <div className={css.qualificationHeading}>Skills</div>
                  <div className={css.qualificationList}>
                    {skills.map(({ key, label, inputValues }) => (
                      <span key={key} className={classNames(css.qualificationName, companySkills.includes(label) && css.SelectedPills, inputValues?.yearOfExperience?.label && css.experiencePopup)}>
                        {companySkills.includes(label) ? <IconProfileCard type="tick" /> : null}
                        {label}
                        {inputValues?.yearOfExperience?.label
                          ? <span className={css.Skillspopup}>
                            <span className={css.SkillspopupBorder}>
                              Since {inputValues?.yearOfExperience?.label}
                            </span>
                          </span>
                          : null}
                      </span>))}
                  </div>
                </div>
                : null :


              (skillsInOne && skillsInOne.length) ?
                <div className={css.qualificationBox} id={'Skills'}>
                  <div >
                    {skillsInOne?.map(({ key, label, inputValues, childSkills }) => {
                      let favouriteToolss = [], specialtiess = [];
                      if (childSkills && childSkills.length) {
                        childSkills?.map(skill => {
                          const { favouriteTools = [], specialties = [] } = skill;
                          if (favouriteTools) {
                            favouriteToolss = [...new Set([...favouriteToolss, ...favouriteTools?.map(({ label }) => label)])];
                          }
                          if (specialties) {
                            specialtiess = [...new Set([...specialtiess, ...specialties?.map(({ label }) => label)])];
                          }
                        });
                      }
                      return (
                        <span key={key}  >
                          {companySkills.includes(label) ? <IconProfileCard type="tick" /> : null}
                          <div className={css.qualificationHeading} >{(skillsInOne.length == 1) ? null : label}</div>
                          <div className={css.qualificationHeading}>Skills</div>
                          {
                            (childSkills && childSkills.length) ? childSkills?.map(({ favouriteTools, specialties, label, yearExperience }
                            ) => {
                              return <>
                                <div className={css.qualificationList}>
                                  <div className={classNames(css.experiencePopup)}>
                                    <div className={css.parentElement}>{label}</div>
                                    <div className={css.Skillspopup}>
                                      {(yearExperience && yearExperience.label) ? <span className={css.SkillspopupBorder}>
                                        Since {yearExperience.label}
                                      </span> : null}
                                    </div>
                                  </div>

                                </div>
                              </>
                            }
                            ) : null}

                          {firstSkillSpecialties && firstSkillSpecialties?.length > 0 && (
                            <div className={css.qualificationBox}>
                              <div className={css.qualificationHeading}>Specialties</div>
                              <div className={css.qualificationList}>
                                {firstSkillSpecialties?.map(s => (
                                  <div key={s?.key} className={css.qualificationName}>
                                    {s?.label}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {favouriteToolss && favouriteToolss.length
                            ? <div>
                              <div className={css.qualificationHeading}>Tech Tools</div>
                              <div className={css.qualificationList}>
                                {favouriteToolss.map(favouriteTool => (
                                  <div className={css.qualificationName} key={favouriteTool}>
                                    {favouriteTool}
                                  </div>
                                ))}
                              </div>
                            </div>
                            : null}

                          {/* {


                          (childSkills && childSkills.length) ? childSkills?.map(({ favouriteTools, specialties, label, yearExperience }
                          ) => {
                            return <>
                              dss
                              <div className={css.qualificationList}>

                                <div className={classNames(css.experiencePopup)}>
                                  <div className={css.parentElement}>{label}</div>
                                  <div className={css.Skillspopup}>
                                    {(yearExperience && yearExperience.label) ? <span className={css.SkillspopupBorder}>
                                      Since {yearExperience.label}
                                    </span> : null}
                                  </div>
                                </div>

                              </div>

                              {(specialties && specialties.length) ? <div>
                                <div className={css.qualificationHeading}>Specialties</div>
                                <div className={css.qualificationList}>
                                  {specialties?.map(({ label }) => {
                                    return <div className={css.qualificationName}> {(label && typeof label != 'object') ? label : ''}</div>
                                  })}
                                </div>
                              </div> : null}
                              {(favouriteTools && favouriteTools.length) ?
                                <div>
                                  <div className={css.qualificationHeading}>Tech Tools</div>
                                  <div className={css.qualificationList}>

                                    {favouriteTools?.map(({ label }) => {
                                      return <div className={css.qualificationName}>{(label && typeof label != 'object') ? label : ''}</div>
                                    })}
                                  </div>
                                </div>
                                : null}

                            </>
                          }) : null
                        } */}
                        </span>);
                    })}
                  </div>
                </div>
                : (skills && skills.length)
                  ? <div className={css.qualificationBox} id={'Skills'}>
                    <div className={css.qualificationHeading}>Skills</div>
                    <div className={css.qualificationList}>
                      {skills.map(({ key, label, inputValues }) => (
                        <span key={key} className={classNames(css.qualificationName, companySkills.includes(label) && css.SelectedPills, inputValues?.yearOfExperience?.label && css.experiencePopup)}>
                          {companySkills.includes(label) ? <IconProfileCard type="tick" /> : null}
                          {label}
                          {inputValues?.yearOfExperience?.label
                            ? <span className={css.Skillspopup}>
                              <span className={css.SkillspopupBorder}>
                                Since {inputValues?.yearOfExperience?.label}
                              </span>
                            </span>
                            : null}
                        </span>))}
                    </div>
                  </div> : null}

            {uniqueFavTools && uniqueFavTools.length && uniqueFavTools[0] != undefined
              ? <div className={css.qualificationBox} id={'Tools'}>
                <div className={css.qualificationHeading}>Familiar Tools</div>
                <div className={css.qualificationList}>
                  {uniqueFavTools.map((favTool, i) => (
                    <span key={favTool + '-' + i} className={classNames(css.qualificationName, companyFavTools.includes(favTool) && css.SelectedPills)}>
                      {companyFavTools.includes(favTool) ? <IconProfileCard type="tick" /> : null}
                      {favTool}
                    </span>
                  ))}
                </div>
              </div>
              : null}

            {(showPortfolio || isOwnListing) && portfolio && portfolio.length && isAuthenticated
              ? <div className={css.portfolioBox} id={'Portfolio'}>
                <div className={css.portfolioHeader}>
                  <h4>Portfolio ({portfolio.length})</h4>
                  {portfolio.length > 2
                    ? <div className={css.seeAllLink}>
                      <Button onClick={() => setSeeAll('PORTFOLIO')}>See All ({portfolio.length})</Button>
                    </div>
                    : null}
                </div>
                <div className={css.portfolioSlider}>
                  <Slider {...settings}>
                    {portfolio.map((p, i) => {
                      const { title, tellMore_1, tellMore_2, tellMore_3, tellMore_4, tellMore_5 = '', e, imageURL, ...rest } = p;
                      return (i < 2 &&
                        <div key={title} className={css.sliderBox}>
                          <div className={css.sliderImage}>
                            {Object.values(rest).length
                              ? <Slider {...portfolioSettings}>
                                {Object.values(rest).map((rost, i) => {
                                  if (rost && typeof rost == 'string') {
                                    return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(rost)
                                      ? <img src={rost} key={i} onClick={() => setIsFullscreen(rost)} />
                                      : (/\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i).test(rost)
                                        ? <video controls key={i} onClick={() => setIsFullscreen(rost)} >
                                          <source alt={'video'} src={rost} type="video/mp4" />
                                        </video>
                                        : (/\.(pdf|doc?x)$/i).test(rost)
                                          ? <div className={css.uploadDocument} key={i} onClick={() => setIsFullscreen(rost.replace(/\.(pdf|doc?x)$/i, '.png'))} >
                                            <img src={rost.replace(/\.(pdf|doc?x)$/i, '.png')} height={'250px'} width={'100%'} />
                                          </div>
                                          : null
                                  }
                                  return null;
                                })}
                              </Slider>
                              : null}
                          </div>
                          <div className={css.sliderData}>
                            <div className={css.sliderHeading}>
                              {title}
                            </div>
                            <div className={css.sliderSubHeading}>
                              <div className={css.moreSub}><span>{tellMore_1}</span>
                                {tellMore_2 ? <p onClick={() => { setOpenModal({ show: true, data: { ...p } }) }}>See all</p> : null}</div>

                            </div>
                            {imageURL
                              ? <a href={imageURL} target='_blank'>
                                {imageURL}
                              </a>
                              : null}
                            {/* <div className={css.sliderSubHeading}>
                              {tellMore}
                            </div> */}
                          </div>
                        </div>
                      )
                    })}
                  </Slider>
                </div>
              </div>
              : null}
            {(people && people.length && (showPortfolio || isOwnListing))
              ? <div className={classNames(css.qaBox, css.qaBoxSmallPadding)}>
                <div className={css.qaHeading}>My Recommendations</div>
                <div className={css.qaBoxWrapper}>
                  {people.map((p, i) => (
                    <div className={css.qaBoxList} key={p.name + '-' + i}>
                      <div className={css.iconWrapper}>
                        <a href={p.linkedinURL} target='_blank'>
                          <IconDeetsLinkedin />
                        </a>
                      </div>
                      <div className={css.deetsFrom}><span className={css.ProDeetsLabel}>From:</span> <span>{p.name}</span></div>

                      <div className={css.deetsHeading}>What they said:</div>
                      <div className={css.deetsDescription}>
                        {typeof p.deets == 'string' ? showMore == ('deets-' + i) || p.deets.length <= 141 ? p.deets : stringFromLength(p.deets, 138, true) : null}
                        {p?.deets?.length > 138
                          ? <span
                            className={css.showmore}
                            onClick={() => setSeeAll('PEOPLE')}
                          >
                            {showMore == ('deets-' + i) ? ' READ LESS' : ' READ MORE'}
                          </span>
                          : null}
                      </div>
                    </div>))}
                </div>
              </div>
              : null}
          </div>
        </div>
      </div>
      <div className={css.listingFixBottom}>
        <div className={css.listingBottom}>
          <div className={css.leftLinks}>
            {filterTabs && filterTabs.length
              ? filterTabs.map((tab, i) => (
                <Link
                  key={tab + i}
                  onClick={(e) => {
                    setCurrentTab(tab);
                    scrollPage(e, tab);
                  }}
                  to={`#${tab}`}
                  href={`#${tab}`}
                  className={currentTab == tab ? css.sectionTab : ''}
                >{tab}</Link>
              ))
              : null}
          </div>
          <div className={css.rightLinks}>
            <div className={css.availableData}>
              {accountType === "fractionalPro" ?
                <>
                  {currentListingPrice?.price ? <>
                    {currentListingPrice && <div className={css.negotiableText}>
                      <span>{newPrice?.formattedPrice}</span> {boardMember ? '/month' : '/hour'} (negotiable)
                    </div>}
                    {currentListingPrice && currentListingPrice?.availableHoursPerWeek
                      ? <div className={css.availableText}>
                        Available for {currentListingPrice?.availableHoursPerWeek.label} {boardMember ? 'per month' : 'per week'}
                      </div>
                      : null}
                  </> : <div className={css.negotiableText}>The price has not yet been set by the listing author. </div>}
                </> : null
              }
              {accountType === "company" && (
                <>
                  {selectedRateAndHours?.price ? (
                    <>
                      {formattedPrice ? (
                        <div className={css.negotiableText}>
                          <span>{formattedPrice}</span>{" "}
                          {boardMember ? "/month" : "/hour"} (negotiable)
                        </div>
                      ) : (
                        formattedPriceFractional
                      )}
                      {selectedRateAndHours?.availableHoursPerWeek && (
                        <div className={css.availableText}>
                          Available for {selectedRateAndHours.availableHoursPerWeek.label}{" "}
                          {boardMember ? "per month" : "per week"}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className={css.negotiableText}>
                      The price has not yet been set by the listing author.
                    </div>
                  )}
                </>
              )}
            </div>
            {!isAuthenticated || (currentUser && currentUser?.id && currentUser?.attributes?.profile?.publicData?.accountType == 'company')
              ? <div className={css.requestButton}>
                <Button
                  disabled={((filteredExperiences && filteredExperiences.length) ? false : true) || isClosed || parentJobRolesInProgress || !selectedRateAndHours?.price}
                  onClick={() => isAuthenticated
                    ? setShowModal('Request')
                    : history.push(createResourceLocatorString('LoginPage', routeConfiguration(), {}, {}))}
                  inProgress={parentJobRolesInProgress}
                >
                  {isAuthenticated
                    ? (tokensToDeduct)
                      ? `Request Connection - ${tokensToDeduct} Tokens`
                      : 'Request Connection'
                    : 'Signup'}
                </Button>
              </div>
              : null}
          </div>
        </div>
      </div>
      {isFullscreen
        ? <div className={css.fullScreenView}>
          <span
            className={css.closeFullScreen}
            onClick={() => setIsFullscreen(false)}
          >
            <IconClose />
          </span>
          <ResponsiveImage
            className={css.responsiveImage}
            alt={'PORTFLIO'}
            url={isFullscreen}
          />
        </div>
        : null}
      <Modal
        id="ListingPage.SeAllModalForPort"
        isOpen={openModal?.show}
        onClose={() => setOpenModal({ show: false, data: {} })}
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.modalDetails}
      ><div className={classNames(css.leftGird, css.modalSlider, css.rightGrid)}><div className={css.portfolioBox}>
        <div className={css.portfolioSlider}>
          <div className={css.portfolioHeader}>
            {/* <h4>Portfolio </h4> */}
          </div>

          <div key={openModal?.data.title} className={css.sliderBox}>

            <div className={css.sliderData}>
              <div className={css.sliderHeading}>
                {openModal.data.title}
              </div>

              <ul className={css.sliderSubHeading}>
                <li>
                  {openModal?.data?.tellMore_1}
                </li>
                {openModal?.data?.tellMore_2 ? <li>
                  {openModal?.data?.tellMore_2}
                </li> : null}
                {openModal?.data?.tellMore_3 ? <li>
                  {openModal?.data?.tellMore_3}
                </li> : null}
                {openModal?.data?.tellMore_4 ? <li>
                  {openModal?.data?.tellMore_4}
                </li> : null}
                {openModal?.data?.tellMore_5 ? <li>
                  {openModal?.data?.tellMore_5}
                </li> : null}


              </ul>
            </div>
          </div>
        </div>
      </div>  </div></Modal>

      <Modal
        id="ListingPage.SeAllModal"
        isOpen={!!seeAll}
        onClose={() => setSeeAll(false)}
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.modalDetails}
      >
        <div className={classNames(css.leftGird, css.modalSlider, css.rightGrid)}>
          {seeAll == "PORTFOLIO"
            ? <div className={css.portfolioBox}>
              <div className={css.portfolioSlider}>
                <div className={css.portfolioHeader}>
                  <h4>Portfolio ({portfolio?.length})</h4>
                </div>
                <Slider {...settings} dots={false}>
                  {portfolio.map(p => {
                    const { title, tellMore_1, tellMore_2, tellMore_3, tellMore_4, tellMore_5, imageURL, ...rest } = p;
                    return (
                      <div key={title} className={css.sliderBox}>
                        <div className={css.sliderImage}>
                          {Object.values(rest)?.length
                            ? <Slider {...portfolioSettings}>
                              {Object.values(rest).map((rost, i) => {
                                const rostSplit = rost.split('/');
                                return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(rost)
                                  ? <img src={rost} key={i} />
                                  : (/\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i).test(rost)
                                    ? <video controls key={i} >
                                      <source alt={'video'} src={rost} type="video/mp4" />
                                    </video>
                                    : (/\.(pdf|doc?x)$/i).test(rost)
                                      ? <div className={css.uploadDocument} key={i} >
                                        <img src={rost.replace(/\.(pdf|doc?x)$/i, '.png')} height={'250px'} width={'100%'} />
                                      </div>
                                      : null
                              })}
                            </Slider>
                            : null}
                        </div>
                        <div className={css.sliderData}>
                          <div className={css.sliderHeading}>
                            {title}
                          </div>
                          {imageURL
                            ? <a href={imageURL} target='_blank'>
                              {imageURL}
                            </a>
                            : null}
                          <ul className={css.sliderSubHeading}>
                            <li>
                              {tellMore_1}
                            </li>
                            {tellMore_2 ? <li>
                              {tellMore_2}
                            </li> : null}
                            {tellMore_3 ? <li>
                              {tellMore_3}
                            </li> : null}
                            {tellMore_4 ? <li>
                              {tellMore_4}
                            </li> : null}
                            {tellMore_5 ? <li>
                              {tellMore_5}
                            </li> : null}
                          </ul>
                        </div>
                      </div>
                    )
                  })}
                </Slider>
              </div>
            </div>
            : seeAll == "EDUCATION"
              ? <div className={css.careerHistory} id={'Education'}>
                <div className={css.careeerHeader}>
                  <h4>Education</h4>

                </div>
                <div className={css.careerGrid}>
                  {educations.map(ed => {
                    const { institution, completedDegree = {}, ...rest } = ed;
                    return (institution && completedDegree && completedDegree.label) ?
                      <div className={css.careerList} key={institution}>
                        <div className={css.companyHeld}>{institution} | {completedDegree.label}</div>
                        {/* {Object.values(rest).map((acheivement, i) => (
                          <div key={i} className={css.careerDescription}>
                            {acheivement}
                          </div>))} */}
                      </div> : null
                  })}
                </div>
              </div>
              : seeAll == "EXPERIENCE"
                ? <div className={css.careerHistory} id={'History'}>
                  <div className={css.careeerHeader}>
                    <h4>Past Roles</h4>

                  </div>
                  <div className={css.careerGrid}>
                    {experiences.map(ex => {
                      const {
                        key,
                        label,
                        highlights = [],
                        inputValues: {
                          industry = {},
                          yearOfExperience = {}
                        }
                      } = ex;

                      return (
                        <div className={css.careerList} key={key}>
                          <div className={css.companyHeld}>{industry.label} | {label}</div>
                          <div className={css.careerDate}>{yearOfExperience.label}</div>
                          {highlights.map((hi, i) => (
                            <div key={key + i} className={css.careerDescription}>
                              {hi}
                            </div>
                          ))}
                        </div>
                      )
                    })}
                  </div>
                </div>
                : seeAll == "REVIEWS"
                  ? <div className={css.reviewContainer} id={'Reviews'}>
                    <div className={css.reviewHeader}>
                      <h4>Reviews</h4>

                    </div>
                    <div className={css.reviewBox}>
                      {reviews.map((review) => {
                        const {
                          author: {
                            attributes: {
                              displayName,
                              firstName,
                              lastName
                            }
                          },
                          content } = review || {};

                        return (
                          <div className={css.reviewList} key={review.id.uuid}>
                            <div className={css.reviewLeftSide}>
                              <Avatar user={review.author} />
                            </div>
                            <div className={css.reviewRightSide}>
                              <div className={css.ratingStar}>
                                <ReviewRating rating={review.attributes.rating} />
                              </div>
                              <div className={css.reviewName}>
                                <span className={css.boldName}>{displayName}</span>
                                <span className={css.normalName}>| {`${firstName} ${lastName}`}</span>
                              </div>
                              <div className={css.reviewMessage}>
                                {content}
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  : seeAll == "PEOPLE"
                    ? <div className={classNames(css.qaBox, css.qaBoxModal)}>
                      <div className={css.qaHeading}>My Deets</div>
                      <div className={css.qaBoxWrapper}>
                        {people.map((p, i) => (
                          <div className={css.qaBoxList}>
                            <div className={css.iconWrapper}>
                              <a href={p.linkedinURL} target='_blank'>
                                <IconDeetsLinkedin />
                              </a>
                            </div>
                            <div className={css.deetsFrom}><span className={css.ProDeetsLabel}>From:</span> {p.name} </div>

                            <div className={css.deetsHeading}>What They Said:</div>

                            <div className={css.deetsDescription}>
                              {p.deets}
                            </div>
                          </div>))}
                      </div>
                    </div>
                    : null}
        </div>
      </Modal>
    </>
  );
};

export default SectionPro;